// Only group-screen drill-down links select a project on entry. Normal menu
// navigation keeps its existing manager and subsystem authentication behavior.
export async function enterGroupDevice (to, from, next) {
  const query = to.query || {}
  if (query.source !== 'group-asset-command') return next()
  const managerId = typeof query.managerId === 'string' ? query.managerId.trim() : ''
  if (!/^\d+$/.test(managerId)) return next('/401')
  try {
    const [{ default: store }, { getManagerListByUser }, { canAccessSmartDeviceMenus }] = await Promise.all([
      import('@/store'), import('@/api/manager'), import('@/config/smartDeviceAccess')
    ])
    const response = await getManagerListByUser()
    if (!response || String(response.code) !== '200' || !Array.isArray(response.data)) throw new Error('manager-list-unavailable')
    const manager = response.data.find(item => String(item.managerId) === managerId)
    if (!manager || (to.path === '/device/lightingControl' && !canAccessSmartDeviceMenus(manager.managerId))) return next('/401')
    // Resolve access before mounting the device page, so it never loads another
    // project's devices or constructs an iframe URL with the previous manager.
    store.commit('manager/SET_MANAGER_LIST', response.data)
    store.commit('manager/SET_CURRENT_MANAGER', manager)
    store.commit('manager/SET_CURRENT_MANAGER_ID', manager.managerId)
    next()
  } catch (error) {
    const { Message } = await import('element-ui')
    Message.error('项目权限暂时无法确认，请稍后重试')
    next('/group/energy-map-screen')
  }
}
